module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix",
    class: _vm.classObject
  }, [_vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76cbc87b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Clearfix.vue
// module id = 1841
// module chunks = 1